import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Play } from 'lucide-react';
import { trackCtaClick } from '../lib/analytics';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#101F27] via-[#37464F] to-[#101F27]">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#009688]/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#005B4F]/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,217,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,217,255,0.03)_1px,transparent_1px)] bg-[size:64px_64px]"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-left space-y-8">
            {/* Badge */}
            <div className="inline-flex items-center space-x-2 bg-[#009688]/10 border border-[#009688]/30 rounded-full px-4 py-2">
              <div className="w-2 h-2 bg-[#009688] rounded-full animate-pulse"></div>
              <span className="text-[#009688] text-sm font-medium">Trusted by 100+ Global Brands</span>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
              <span className="text-white">WristCoin Cashless </span>
              <span className="bg-gradient-to-r from-[#009688] to-[#005B4F] bg-clip-text text-transparent">
                Payments &amp; POS
              </span>
            </h1>

            {/* Subheading */}
            <p className="text-xl text-gray-400 max-w-xl">
              Stop leaving revenue on the table. Our RFID-powered cashless platform drives 20%+ sales growth while turning every transaction into a seamless guest moment.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                asChild
                size="lg"
                className="bg-gradient-to-r from-[#009688] to-[#005B4F] hover:from-[#005B4F] hover:to-[#009688] text-white text-lg px-8 py-6 shadow-lg shadow-[#009688]/30 hover:shadow-[#009688]/50 transition-all duration-300"
              >
                <a
                  href="https://share.hsforms.com/1JU7FumyhQtyEhJbBslXmEgsn91p"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackCtaClick('request_demo', 'hero', { destination: 'hubspot_form' })}
                >
                  Request Demo
                  <ArrowRight className="ml-2" size={20} />
                </a>
              </Button>
              <Button
                onClick={() => {
                  trackCtaClick('watch_demo', 'hero');
                  const element = document.getElementById('video');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                size="lg"
                variant="outline"
                className="border-2 border-[#009688] text-[#009688] hover:bg-[#009688]/10 text-lg px-8 py-6"
              >
                <Play className="mr-2" size={20} />
                Watch Demo
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="space-y-1">
                <div className="text-3xl font-bold text-[#009688]">&lt;1s</div>
                <div className="text-sm text-gray-400">Transaction Time</div>
              </div>
              <div className="space-y-1">
                <div className="text-3xl font-bold text-[#009688]">20%+</div>
                <div className="text-sm text-gray-400">Sales Increase</div>
              </div>
              <div className="space-y-1">
                <div className="text-3xl font-bold text-[#009688]">Works Offline.</div>
                <div className="text-sm text-gray-400">No internet, No problem</div>
              </div>
            </div>
          </div>

          {/* Right Content - Hero Image */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="/images/landing_page_hero.png"
                alt="WristCoin RFID Payment System"
                className="rounded-2xl shadow-2xl shadow-[#009688]/20"
              />
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-72 h-72 bg-gradient-to-r from-[#009688] to-[#005B4F] rounded-full blur-3xl opacity-20"></div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#009688]/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-[#009688] rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
